import { Injectable } from '@angular/core';
import { Firestore, collection, doc, query, where } from '@angular/fire/firestore';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as fromWeightActions from '../actions/weights.actions';

import { Observable, of } from 'rxjs';
import { map, catchError, switchMap, take } from 'rxjs/operators';
import { FirebaseService } from '../../services/firebase/firebase.service';
import { WeightFirebaseResponse } from '../../models/weights.model';

@Injectable()
export class WeightsEffects {

    constructor(
        private readonly action$: Actions,
        private readonly firestore: Firestore,
        private readonly firebaseService: FirebaseService,
    ) { }

    // Load Weight
    loadWeight$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromWeightActions.LoadWeightAction),
        switchMap(({ data }) => {
            const userRef = doc(this.firestore, `users/${data.id}`);
    
            const ref = query(
                collection(this.firestore, 'weights'),
                where('userRef', '==', userRef)
            );

            return this.firebaseService.getDataOfCollectionByField(ref).pipe(take(1), map((resp) => resp.map((doc) => ({
                ...doc as WeightFirebaseResponse
            }))));
        }),
        map((data) => {
            let weight: WeightFirebaseResponse = { weights: [] };
            if (data?.length > 0) {
                weight = data[0];
                weight.weights = weight.weights.map((weight) => ({ ...weight, date: new Date((weight.date as unknown as { seconds: number }).seconds * 1000) }))
                delete weight.userRef;
            }
            return ({ type: fromWeightActions.LOAD_WEIGHT_SUCCESS, data: weight });
        }),
        catchError(error => of({ type: fromWeightActions.LOAD_WEIGHT_FAIL, error: error }))
    ));

    // Add Weight
    addWeight$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromWeightActions.AddWeightAction),
        switchMap(async ({ data, user }) => {
            const userRef = doc(this.firestore, `users/${user.id}`);
            const weight: WeightFirebaseResponse = {
                ...data,
                userRef
            };

            const resp = await this.firebaseService.addDoc('weights', weight);

            return { ...data, id: resp.id };
        }),
        map((data) => ({ type: fromWeightActions.ADD_WEIGHT_SUCCESS, data })),
        catchError(error => of({ type: fromWeightActions.ADD_WEIGHT_FAIL, error: error }))
    ));

    // Update Weight
    updateWeight$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromWeightActions.UpdateWeightAction),
        switchMap(async ({ data, user }) => {
            const userRef = doc(this.firestore, `users/${user.id}`);
            const weight: WeightFirebaseResponse = {
                ...data,
                userRef
            };
            delete weight.id;

            await this.firebaseService.updateDoc('weights', data.id!, weight);
            return data;
        }),
        map((data) => ({ type: fromWeightActions.UPDATE_WEIGHT_SUCCESS, data })),
        catchError(error => of({ type: fromWeightActions.UPDATE_WEIGHT_FAIL, error: error }))
    ));
}